import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import Bannerimg from "../../../images/banner/analytics-banner.webp";
const Analytics = () => {
  const banner = {
    title: "Analytics",
    image: Bannerimg,
  };
  return (
    <>
      <Helmet>
        <title>
          Analytics — Cylon Technologies – Big Data | Data Analytics | Digital
          Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content pb-5 ">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Analytics </h2>
              <p>
                We at Cylon are experts in Datawarehouse, Data analytics, be it
                traditional datawarehouse techniques or bigdata or real time
                analytics. We put your data to work, enabling real time
                analytics, enabling decision making more accurately, efficiently
                and by saving time and cost.
              </p>
              <h5>Few of our Services includes, but not limited to:</h5>
              <ul className="big_li">
                <li>Assessment & Roadmaps</li>
                <li>Solution Architecture</li>
                <li>Enterprise & BigData Architecture & Roadmap</li>
                <li>Data Governance</li>
                <li>Data Quality Solutions</li>
                <li>Data Virtualizations</li>
                <li>Data Science</li>
                <li>Master Data Management</li>
                <li>Business Intelligence</li>
              </ul>
            </div>
            <div className="col-md-4">
              <div className="border-tb right_content text-center">
                <h5>Connect</h5>
                <h5 className="mb-4">
                  <b>with us</b>
                </h5>
                <p>
                  Cylon can help you better prepare to adapt high speed change
                  and be highly competitive in digital world of analytics.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Analytics;
